export { default } from './TemesRelacionats';
